import { useEffect } from "react";
import { useModals } from "../../../../context/ModalContext";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { useVirtualAssistant } from "../../context/VirtualAssistantContext";
import { LinkClientPickerContent } from "./LinkClientPickerContent";
import { LinkVendorPickerContent } from "./LinkVendorPickerContent";
import { LinkWorkforcePickerContent } from "./LinkWorkforcePickerContent";

export const LINK_CLIENT_MODAL_KEY = "VR-Link-Client-Picker";
export const LINK_PROSPECT_MODAL_KEY = "VR-Link-Prospect-Picker";
export const LINK_WORKFORCE_MODAL_KEY = "VR-Link-Workforce-Picker";
export const LINK_APPLICANT_MODAL_KEY = "VR-Link-Applicant-Picker";
export const LINK_VENDOR_MODAL_KEY = "VR-Link-Vendor-Picker";
export const LINK_VENDOR_PROSPECT_MODAL_KEY = "VR-Link-Vendor-Prospect-Picker";

export function VirtualReceptionistLinkPickersHost() {
  const {
    linkClientPhone,
    linkProspectPhone,
    linkWorkforcePhone,
    linkApplicantPhone,
    linkVendorPhone,
    linkVendorProspectPhone,
    clearLinkClientPhone,
    clearLinkProspectPhone,
    clearLinkWorkforcePhone,
    clearLinkApplicantPhone,
    clearLinkVendorPhone,
    clearLinkVendorProspectPhone,
  } = useVirtualAssistant();
  const { closeByKey, openModal } = useModals();

  useEffect(() => {
    if (linkClientPhone) {
      const content = <LinkClientPickerContent phoneNumber={linkClientPhone} onDone={handleCloseClientPicker} initialActiveTable="clients" />;
      openModal({ key: LINK_CLIENT_MODAL_KEY, preventParentTrigger: true }, content);
    }
  }, [linkClientPhone]);

  useEffect(() => {
    if (linkProspectPhone) {
      const content = <LinkClientPickerContent phoneNumber={linkProspectPhone} onDone={handleCloseProspectPicker} initialActiveTable="prospects" />;
      openModal({ key: LINK_PROSPECT_MODAL_KEY, preventParentTrigger: true }, content);
    }
  }, [linkProspectPhone]);

  useEffect(() => {
    if (linkWorkforcePhone) {
      const content = <LinkWorkforcePickerContent phoneNumber={linkWorkforcePhone} onDone={handleCloseWorkforcePicker} initialFilter="all" />;
      openModal({ key: LINK_WORKFORCE_MODAL_KEY, preventParentTrigger: true }, content);
    }
  }, [linkWorkforcePhone]);

  useEffect(() => {
    if (linkApplicantPhone) {
      const content = <LinkWorkforcePickerContent phoneNumber={linkApplicantPhone} onDone={handleCloseApplicantPicker} initialFilter="applicant" />;
      openModal({ key: LINK_APPLICANT_MODAL_KEY, preventParentTrigger: true }, content);
    }
  }, [linkApplicantPhone]);

  useEffect(() => {
    if (linkVendorPhone) {
      const content = <LinkVendorPickerContent phoneNumber={linkVendorPhone} onDone={handleCloseVendorPicker} initialActiveTable="vendors" />;
      openModal({ key: LINK_VENDOR_MODAL_KEY, preventParentTrigger: true }, content);
    }
  }, [linkVendorPhone]);

  useEffect(() => {
    if (linkVendorProspectPhone) {
      const content = (
        <LinkVendorPickerContent phoneNumber={linkVendorProspectPhone} onDone={handleCloseVendorProspectPicker} initialActiveTable="prospects" />
      );
      openModal({ key: LINK_VENDOR_PROSPECT_MODAL_KEY, preventParentTrigger: true }, content);
    }
  }, [linkVendorProspectPhone]);

  const handleCloseClientPicker = () => {
    clearLinkClientPhone();
    closeByKey(LINK_CLIENT_MODAL_KEY);
  };

  const handleCloseProspectPicker = () => {
    clearLinkProspectPhone();
    closeByKey(LINK_PROSPECT_MODAL_KEY);
  };

  const handleCloseWorkforcePicker = () => {
    clearLinkWorkforcePhone();
    closeByKey(LINK_WORKFORCE_MODAL_KEY);
  };

  const handleCloseApplicantPicker = () => {
    clearLinkApplicantPhone();
    closeByKey(LINK_APPLICANT_MODAL_KEY);
  };

  const handleCloseVendorPicker = () => {
    clearLinkVendorPhone();
    closeByKey(LINK_VENDOR_MODAL_KEY);
  };

  const handleCloseVendorProspectPicker = () => {
    clearLinkVendorProspectPhone();
    closeByKey(LINK_VENDOR_PROSPECT_MODAL_KEY);
  };

  return (
    <>
      <BaseModalComponent
        modalKey={LINK_CLIENT_MODAL_KEY}
        modalLabel="Link Client"
        onClose={handleCloseClientPicker}
        defaultSizes={{ width: 920, height: 640 }}
        fitContentHeight={false}
      >
        {linkClientPhone ? (
          <LinkClientPickerContent phoneNumber={linkClientPhone} onDone={handleCloseClientPicker} initialActiveTable="clients" />
        ) : null}
      </BaseModalComponent>

      <BaseModalComponent
        modalKey={LINK_PROSPECT_MODAL_KEY}
        modalLabel="Link Prospect"
        onClose={handleCloseProspectPicker}
        defaultSizes={{ width: 920, height: 640 }}
        fitContentHeight={false}
      >
        {linkProspectPhone ? (
          <LinkClientPickerContent phoneNumber={linkProspectPhone} onDone={handleCloseProspectPicker} initialActiveTable="prospects" />
        ) : null}
      </BaseModalComponent>

      <BaseModalComponent
        modalKey={LINK_WORKFORCE_MODAL_KEY}
        modalLabel="Link Workforce Member"
        onClose={handleCloseWorkforcePicker}
        defaultSizes={{ width: 920, height: 640 }}
        fitContentHeight={false}
      >
        {linkWorkforcePhone ? (
          <LinkWorkforcePickerContent phoneNumber={linkWorkforcePhone} onDone={handleCloseWorkforcePicker} initialFilter="all" />
        ) : null}
      </BaseModalComponent>

      <BaseModalComponent
        modalKey={LINK_APPLICANT_MODAL_KEY}
        modalLabel="Link Applicant"
        onClose={handleCloseApplicantPicker}
        defaultSizes={{ width: 920, height: 640 }}
        fitContentHeight={false}
      >
        {linkApplicantPhone ? (
          <LinkWorkforcePickerContent phoneNumber={linkApplicantPhone} onDone={handleCloseApplicantPicker} initialFilter="applicant" />
        ) : null}
      </BaseModalComponent>

      <BaseModalComponent
        modalKey={LINK_VENDOR_MODAL_KEY}
        modalLabel="Link Vendor"
        onClose={handleCloseVendorPicker}
        defaultSizes={{ width: 920, height: 640 }}
        fitContentHeight={false}
      >
        {linkVendorPhone ? (
          <LinkVendorPickerContent phoneNumber={linkVendorPhone} onDone={handleCloseVendorPicker} initialActiveTable="vendors" />
        ) : null}
      </BaseModalComponent>

      <BaseModalComponent
        modalKey={LINK_VENDOR_PROSPECT_MODAL_KEY}
        modalLabel="Link Vendor Prospect"
        onClose={handleCloseVendorProspectPicker}
        defaultSizes={{ width: 920, height: 640 }}
        fitContentHeight={false}
      >
        {linkVendorProspectPhone ? (
          <LinkVendorPickerContent phoneNumber={linkVendorProspectPhone} onDone={handleCloseVendorProspectPicker} initialActiveTable="prospects" />
        ) : null}
      </BaseModalComponent>
    </>
  );
}
